import './App.css';
import AboutMe from './components/AboutMe/AboutMe';
import Blogs from './components/Blogs/Blogs';
import Header from './components/Header/Header';
import Navbar from './components/Navbar/Navbar';
import Projects from './components/Projects/Projects';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
      Aos.init({
          duration: 700
      })
  }, []);
  
  return (
    <div className="app">
      <Navbar />
      <Header />
      <Projects />
      <Blogs />
      <AboutMe />
    </div>
  );
}

export default App;
